import React from 'react';

const UploadAvatarIcon = () => {
	return (
		<svg
			fill='none'
			height='58'
			viewBox='0 0 58 58'
			width='58'
		>
			<g filter='url(#filter0_d_3736_584112)'>
				<rect fill='white'
					fillOpacity='0.85'
					height='32'
					rx='16'
					shapeRendering='crispEdges'
					width='32'
					x='13'
					y='11'
				/>
				<path d='M24 23L29 18L34 23'
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path d='M29 32L29 18'
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path d='M37 35L21 35'
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
			</g>
			<defs>
				<filter
					colorInterpolationFilters='sRGB'
					filterUnits='userSpaceOnUse'
					height='58'
					id='filter0_d_3736_584112'
					width='58'
					x='0'
					y='0'
				>
					<feFlood
						floodOpacity='0'
						result='BackgroundImageFix'
					/>
					<feColorMatrix in='SourceAlpha'
						result='hardAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
					/>
					<feMorphology
						in='SourceAlpha'
						operator='dilate'
						radius='3'
						result='effect1_dropShadow_3736_584112'
					/>
					<feOffset dy='2'/>
					<feGaussianBlur stdDeviation='5'/>
					<feComposite
						in2='hardAlpha'
						operator='out'
					/>
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0'
					/>
					<feBlend
						in2='BackgroundImageFix'
						mode='normal'
						result='effect1_dropShadow_3736_584112'
					/>
					<feBlend
						in='SourceGraphic'
						in2='effect1_dropShadow_3736_584112'
						mode='normal'
						result='shape'
					/>
				</filter>
			</defs>
		</svg>
	);
};

export default UploadAvatarIcon;
